export default "__VITE_PUBLIC_ASSET__a1ff1e96__"